"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AccordionIcon = function AccordionIcon(_ref) {
  var isOpen = _ref.isOpen;
  return _react["default"].createElement("div", null, _react["default"].createElement(_Icon["default"], {
    style: {
      fontSize: "1.5rem",
      padding: ".75rem",
      color: "#666666"
    },
    iconName: isOpen ? "fa-angle-up" : "fa-angle-down"
  }));
};

AccordionIcon.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired
};
var _default = AccordionIcon;
exports["default"] = _default;